import Subscription from './Subscription'
import {isWithinDaysFromNow, isWithinMonthsFromNow, isWithinYearsFromNow, formatDate} from '../DateUtil'

export default function OfficeHourSubscription(lineItem, enrollment, officeHour) {
  const subscription = Subscription(lineItem, enrollment)

  const self = {
    schedule: officeHour && officeHour.schedule,
    rsvpUrl: officeHour && officeHour.rsvp_url,
    meetingLink: officeHour && officeHour.meeting_link,
    password: officeHour && officeHour.password,
    title: lineItem.title,
    id: `${lineItem.order_id}_${lineItem.id}_${lineItem.quantity_index}`,
    subscriptionExpireAt: lineItem.subscriptionExpireAt,
    // shopper#595 : expire non recurring OH after 6 months
    // shopper#849 : or if subscription.status == expired
    isExpired: !lineItem.subscription_plan_id && (subscription.status == 'expired' || !isWithinMonthsFromNow(lineItem.processed_at, 6))
  }

  self.isActive = !subscription.needsPayment && !self.isExpired

  return Object.assign(subscription, self)
}
